<script setup lang="ts">
import { SfLoaderCircular } from '@storefront-ui/vue';

const { loading, fetchOrders } = useOrders();
const { fetchBulkEligibility } = useReturns();

await Promise.all([fetchOrders(), fetchBulkEligibility()]);
</script>

<template>
  <Navigation>
    <Tabs :tabs="[{ label: $t('My orders'), handle: 'orders' }]">
      <template v-slot="{ activeTab }">
        <div v-if="activeTab.handle === 'orders'">
          <OrdersList />
        </div>
      </template>
    </Tabs>
  </Navigation>
</template>
